import { Controller } from "@hotwired/stimulus"

// The Hubspot conversations SDK is loaded in by GTM and is also
// relatively slow to initialise. GTM loads in these libraries
// right and the end of the page load. All this code is basically a
// wrapper to allow the button to summon the chat to work even if
// hubspot is still loading or initialising.
//
export default class HubspotController extends Controller {
  static targets = ["button"]
  static values = { issueType: String, secureToken: String }

  declare readonly buttonTarget: HTMLButtonElement
  declare readonly buttonTargets: HTMLButtonElement[]
  declare readonly issueTypeValue: string
  declare readonly secureTokenValue: string

  connect() {
    this.enableButton()
  }

  private enableButton() {
    this.buttonTargets.forEach(button => {
      button.removeAttribute("disabled")
      button.removeAttribute("data-tooltip")
    })
  }

  private setButtonLoading() {
    this.buttonTargets.forEach(button => {
      button.setAttribute("disabled", "disabled")
      button.setAttribute("data-tooltip", "Opening chat...")
    })
  }

  openChatWidget() {
    this.setButtonLoading()
    void this.doOpen()
  }

  private openHubspotWidget() {
    const hs = window.HubSpotConversations
    if (hs) hs.widget.open()
  }

  private doOpen() {
    const params = new URLSearchParams({ issue_type: this.issueTypeValue })
    if (this.secureTokenValue) params.set("secure_token", this.secureTokenValue)
    window.location.href = `/support/chat?${params.toString()}`
  }
}
